import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component WarningTriangleIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <WarningTriangleIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <WarningTriangleIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const WarningTriangleIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="WarningTriangleIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M13.08 2.247c.381.185.694.465.902.805l8.742 14.964c.597.978.194 2.204-.9 2.738a2.5 2.5 0 0 1-1.082.246H3.258C2.01 21 1 20.097 1 18.982c0-.337.095-.67.276-.966l8.742-14.964c.597-.978 1.968-1.339 3.063-.805M12 4 3 19h18zm0 7a3 3 0 1 1 0 6 3 3 0 0 1 0-6"
      />
    </svg>
  )
);
WarningTriangleIcon.displayName = "WarningTriangleIcon";
export default WarningTriangleIcon;
